if ( window.jQuery ) window.$ = jQuery;

import commonPluginGBC from './routes/common';

// Import CSS
import '../styles/main.scss';

document.addEventListener("DOMContentLoaded", (event) => {
    console.log ('loadPlugin');

    commonPluginGBC.init();
    commonPluginGBC.finalize();
});
